import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { FiPlus } from "react-icons/fi";
import { parseJWT } from "../../../utils/jwtUtils";
import Table from "../../components/Table";
import { viewUser, deleteUser } from "../../../states/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import Layout from "../../pages/layout/Layout";
import Loading from "../loading/Loading";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const ViewUser = () => {
  // dispatch
  const dispatch = useDispatch();
  // hooks
  const users = useSelector((state) => state.users);
  // use effect
  useEffect(() => {
    dispatch(viewUser());
  }, []);

  const navigate = useNavigate();

  const handleUpdateUser = (data) => {
    navigate("/updateUser/" + data.id);
  };

  function handleRemoveUser(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!"
      )
    ) {
      dispatch(deleteUser(data.id));
    }
    setTimeout(function () {
      dispatch(viewUser());
    }, 500);
  }

  const token = localStorage.getItem("userInfo");
  // Parse the token
  const userRole = parseJWT(token);

  // console.log("user role is : ", userRole);
  const isAdminOrSupperAdmin =
    userRole?.role === "supperAdmin" || userRole.role === "admin";
  const isUser = userRole.role === "user";
  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <Layout title={"Users"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">{translate("All users")}</Typography>
          <Link to="/signup" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              sx={{ borderRadius: "5px" }}
            >
              {translate("New_User")}
            </Button>
          </Link>
        </Box>
        {users?.users ? (
          <Table
            data={users?.users}
            fields={UserColumns}
            numberOfRows={users?.users?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveUser}
            upDatefunction={handleUpdateUser}
            routeLink="single-user"
          />
        ) : (
          <Loading />
        )}
      </Box>
      <ToastContainer />
    </Layout>
  );
};

export default ViewUser;

export const UserColumns = [
  {
    accessorKey: "photo1", //access nested data with dot notation
    header: "Images",
    size: 100,
    Cell: ({ cell }) => (
      <div>
        <Avatar
          src={`${BaseUrl}${cell.getValue()}`}
          sx={{ width: 30, height: 30 }}
        />
      </div>
    ),
  },
  {
    accessorKey: "firstName", //access nested data with dot notation
    header: "First Name",
  },
  {
    accessorKey: "role", //access nested data with dot notation
    header: "Role",
  },
  // {
  //   accessorKey: "contactNumber", //access nested data with dot notation
  //   header: "Contact Number",
  // },
  {
    accessorKey: "phone", //access nested data with dot notation
    header: "Phone No",
  },
];
